import gql from 'graphql-tag';

const PRICE_SUGGESTIONS_QUERY = gql`
  query PriceSuggestions($listingIds: [ID!]) {
    priceSuggestions(listingIds: $listingIds) {
      suggestedPrice
    }
  }
`;

const getPriceSuggestions = client => listingIds =>
  client.query({
    fetchPolicy: 'network-only',
    query: PRICE_SUGGESTIONS_QUERY,
    variables: {
      listingIds
    }
  });

export default getPriceSuggestions;
